// "Aparecer no ranking da cidade" (canvas 0.3, 7.8): a opção nasce ligada quando o jogador escolhe a cidade e vale
// para o ranking da cidade, o do estado e a cidade no perfil público. Base legal: legítimo interesse, com opção de
// sair no Perfil e em Configurações. Quem desliga fica desligado, mesmo trocando de cidade.
import { useId } from 'react';
import { useCidades } from '../telas/CampoCidade.tsx';

export function IconeTrofeu({ tamanho = 22 }: { tamanho?: number }) {
  return (
    <svg width={tamanho} height={tamanho} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4z" /><path d="M17 5h3v2a3 3 0 0 1-3 3M7 5H4v2a3 3 0 0 0 3 3" />
    </svg>
  );
}

// O nome e a UF da cidade do IBGE ("Carapicuíba", "SP"), quando a lista já carregou.
export function useLugar(codigo: number | null): { nome: string; uf: string } | null {
  const busca = useCidades();
  const m = codigo && busca ? busca.porCodigo(codigo) : undefined;
  return m ? { nome: m.nome, uf: m.uf } : null;
}

// A chave, no formulário do perfil (dentro do form: type="button") e em Configurações. Sem cidade, não aparece.
export function ChaveRankingCidade({ codigo, ligado, aoMudar, ocupado = false, configuracoes = false }: {
  codigo: number | null; ligado: boolean; aoMudar: (ligado: boolean) => void; ocupado?: boolean; configuracoes?: boolean;
}) {
  const id = useId();
  const lugar = useLugar(codigo);
  if (!codigo) return null;
  const rotulo = configuracoes ? 'Ranking da cidade e do estado' : 'Aparecer no ranking da cidade';
  const apoio = configuracoes
    ? `${lugar ? `${lugar.nome} · ${lugar.uf}. ` : ''}O Brasil vale sempre`
    : ligado
      ? `Já vem ligado. Seu apelido entra no ranking ${lugar ? `de ${lugar.nome} e de ${lugar.uf}` : 'da sua cidade e do seu estado'}.`
      : 'Desligado: você aparece só no ranking do Brasil.';
  return (
    <section className={'cartao chave-ranking' + (ligado ? ' on' : '')} aria-label={rotulo}>
      <div className="linha-chave">
        <span className="icone-whats"><IconeTrofeu /></span>
        <span className="texto-chave">
          <b id={id + 'r'}>{rotulo}</b>
          <small id={id + 'a'}>{apoio}</small>
        </span>
        <button type="button" role="switch" aria-checked={ligado} aria-labelledby={id + 'r'} aria-describedby={id + 'a'} disabled={ocupado}
          className={'chave-whats' + (ligado ? ' on' : '')} onClick={() => aoMudar(!ligado)}>
          <span className="bolinha" />
        </button>
      </div>
    </section>
  );
}

// Aviso único no Início para quem a migração ligou: Ok tira o aviso; Desligar tira o aviso e desliga.
export function CartaoAvisoRanking({ codigo, aoResponder }: { codigo: number | null; aoResponder: (desligar: boolean) => void }) {
  const lugar = useLugar(codigo);
  return (
    <section className="cartao aviso-ranking-cidade" aria-label="Ranking da cidade">
      <p><IconeTrofeu tamanho={20} /><span>Agora você aparece no ranking {lugar ? `de ${lugar.nome}` : 'da sua cidade'}. Dá para desligar no Perfil.</span></p>
      <div className="dupla">
        <button className="btn2" onClick={() => aoResponder(true)}>Desligar</button>
        <button className="btn2 dourado" onClick={() => aoResponder(false)}>Ok</button>
      </div>
    </section>
  );
}
